import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function AttachModal({
  id,
  attachUsers,
  getAdministratorList,
  administratorList,
  history,
  getSingleEndorsingOffices,
  attaching,
}) {
  const [formData, setFormData] = useState([]);

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    const adminUserList = formData ? formData.map(data => +data.value) : [] || [];

    const args2 = {
      administrators: adminUserList
    }

    attachUsers(id, args2, () => {
      setModal({ isOpen: false });
      getAdministratorList();
      history.push(`/bpls/settings/endorsing-offices/${id}`);
      getSingleEndorsingOffices(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getAdministratorList({
      display_all: 1,
      per_page: 10000
    })
  }, []);  

  const selectAdministrator = administratorList.map(x => ({
    label: `${_.get(x, 'attributes.name')}`,
    value: x.id,
    id: x.id
  }));

  const handleDropDownChange = item => {
    setFormData(
      item
    );
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Select Administrator: 
            </label>
            <Select
              options={selectAdministrator}
              placeholder="Select Administrator"
              onChange={handleDropDownChange
                  // (test) => {
                  // const test = test.forEach(element => {
                  //   /* eslint-disable */
                  //   `${'administrator'[${i}]}` = element.value;
                  // });
                  // setFormData(
                  //   `administrator`[test.value]
                  // )
                  // }
              }
              isMulti
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={attaching}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {attaching ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={attaching}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AttachModal.propTypes = {
  id: PropTypes.string.isRequired,
  getAdministratorList: PropTypes.instanceOf(Function).isRequired,
  administratorList: PropTypes.instanceOf(Array).isRequired,
  attachUsers: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  attaching: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  attaching: api.loading.indexOf(c.ATTACH_ADMINISTRATOR) > -1,
  administratorList: _.get(api, `${c.GET_ADMINISTRATOR}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AttachModal);
